// JsFromRoutes CacheKey 307d72c731ebadd88989aba734249468
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  trackCtaClick: /* #__PURE__ */ definePathHelper('post', '/infotainment/:id/track_cta_click'),
}
